import React from "react";
import { useState } from "react";
import { addParamUrl } from "../../../../utils";
import { GroupSpecialGochiKidDetailModal } from "./GroupSpecialGochiKidDetailModal";
import GochiService from "../../../../api/services/GochiService";
import moment from "moment";
import { GochiKidGroupNoteModal } from "./GochiKidGroupNoteModal";
import { GOCHI_KID_GROUP_NAME_HAS_NOTE } from "../../../../constants";

export function SumugochiErrorModal(props) {
  return (
    <>
      <div
        className={
          props.showing
            ? "custom-modal-container group-special-gochi-kid-modal sumugochi-error-modal show-modal"
            : "custom-modal-container group-special-gochi-kid-modal sumugochi-error-modal"
        }
        size="sm"
      >
        <div
          className={
            props.showing
              ? "modal modal-action modal-dialog is-show history-modal max-width-335"
              : "modal modal-action modal-dialog history-modal max-width-335"
          }
        >
          <div className="modal-header-history">
            <button
              className="modal-btn modal-btn-close"
              id="modalClose"
              onClick={() => props.handleClose()}
              type="button"
            >
              <svg className="icon">
                <title>閉じる</title>
                <use xlinkHref="/assets/img/common/icon.svg#times" />
              </svg>
            </button>
          </div>
          <div className="title-modal title-modal-charge">
            <div className="title">支援元を選ぶ</div>
          </div>
          <div className={`modal-body`}>
            <div className="font-weight-700">
                「{props.listGroupSpecialGochiKidAll[0]?.gochiKidGroupName ?? "Sumuごち"}」をご利用するには、こどもごちめし利用者（お子様）情報の登録が必要です。
                <br />
                <br />
                本サービスは台東区在住の方のみを対象としております。
            </div>
            <br />
            <div>
              現在、お客さまのアカウントは、 こどもごちめしの利用者情報登録が完了していないため、現在支援元を選択できません。
              <br />
              <br />
              下記ページから利用者情報を登録してください。
              <br />
              登録・審査完了後、「{props.listGroupSpecialGochiKidAll[0]?.gochiKidGroupName ?? "Sumuごち"}」をご利用いただけます。
            </div>
            <br />
            <a href="/mypage/kodomo_use">利用者情報を登録する</a>
            <br />
            <br />
            <a href="https://drive.google.com/file/d/18DQ6Krdn1eoXow6h2KNnzEO88a_yc_6G/view" target="_blank">こどもごちめし登録マニュアル</a>
          </div>
        </div>
        <div className="back-drop" />
      </div>
    </>
  );
}
